import React from "react";
import { Col, Row } from 'react-bootstrap'
import Nav from '../components/Nav'
import css from './Layout.module.css'
import AnuncioForm from "../components/AnuncioForm";
import DadosEasyData from "../components/DadosEasyData";


function Layout() {
  return (
      <div className={css.rotate}>
          <Nav />
          <Row>
              <Col xs={12} lg={6} style={{ paddingLeft: '30px' }}>
                  <AnuncioForm />
              </Col>
              <Col xs={12} lg={6}>
                  <DadosEasyData />
              </Col>
          </Row>
      </div>
  )
}

export default Layout;
